import { css } from '@emotion/core';
import { BrowserUtils } from '../../utils';

export const highContrastStyles = color => `
&.vds-divider--standard, &.vds-divider--section {
  color: ${color};
}
`;

export const styles = (theme, cybs) => ({
  divider: css`
    & {
      border-top: 0;
      border-style: solid;
      width: 100%;
    
    }
    &.vds-divider--standard, 
    &.vds-divider--section{
      border-color: ${cybs?.base?.wcag21?.stoneGrey ?? '#62798D'} !important;
    }

    @media all and (-ms-high-contrast: black-on-white) {
      ${highContrastStyles('black')}
    }

    ${BrowserUtils.isHighContrastMode()
      ? highContrastStyles('white')
      : ''}
  `
});

export default styles;